export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.customer_country) {
        return {...state, ...payload.customer_country};
      }
      return state;
    }
  }
};
